export default {
  // 阿拉伯语
  common: {
    confirm: 'تأكيد',
    confirmed: 'تم التأكيد',
    cancel: 'إلغاء',
    select: 'يرجى الاختيار',
    search: 'بحث',
    notice: 'تنبيه',
    confirmRole: 'تأكيد معلومات الشخصية',
    announce: 'إعلان'
  },
  pay: {
    title: {
      SelectCharacter: 'اختر الشخصية',
      SelectBundle: 'تسوق المنتجات',
      game: 'اللعبة',
      gamePlaceholder: 'يرجى اختيار اللعبة',
      server: 'الخادم',
      serverPlaceHolder: 'يرجى اختيار الخادم',
      role: 'الشخصية',
      rolePlaceHolder: 'يرجى اختيار الشخصية'
    },
    instructions: {
      title: 'تعليمات الشحن',
      subtext: 'تعليمات الخدمة',
      paragraph1: '1. لضمان حقوقك، يرجى قراءة وصف المنتج بالتفصيل بعناية قبل عملية الشراء.',
      paragraph2:
        '2. هذه الخدمة متاحة فقط للمستخدمين الذين أنشأوا شخصية داخل اللعبة. المستخدمون الذين لم يُكملوا إنشاء شخصيتهم داخل اللعبة لن تظهر لهم معلومات الخادم أو الشخصية في هذه الصفحة؛ لذا يرجى التأكد من معلومات شخصيتك قبل البدء بالشحن.',
      paragraph3: '3. تنبيه هام: بعد إدخال الخادم ومعرف الشخصية (ID)، يُرجى مراجعة معلومات حسابك بعناية والتأكد من صحتها تماماً قبل المتابعة إلى الخطوة التالية!!',
      paragraph4:
        '4. بعد نجاح عملية الدفع، ستصلك المنتجات التي اشتريتها عبر هذه الصفحة إلى حسابك من خلال صندوق البريد داخل اللعبة. إذا لم تستلم المنتج بعد مرور 30 دقيقة من نجاح الشحن، يرجى التواصل مع خدمة العملاء عبر النافذة العائمة داخل اللعبة، وسنعمل على حلّها في أقرب وقت ممكن.',
      paragraph5:
        '5. قد يتأخر وصول الرصيد أحياناً بسبب تأخر نقل البيانات عبر الشبكة؛ لذا يُعتمد على ما يظهر داخل اللعبة فعلياً مرجعاً نهائياً. في حال وجود أي استفسار، لا تتردد في التواصل مع موظفي خدمة العملاء."'
    },
    Region: 'المنطقة',
    Server: 'الخادم',
    ServerPlaceholder: 'الخادم (انقر للبحث)',
    CharacterID: 'معرف الشخصية',
    CharacterName: 'اسم الشخصية',
    RoleName: 'اسم الشخصية',
    bundelDetails: 'تفاصيل المنتج',
    protocal: {
      services: 'شروط الخدمة',
      policy: 'سياسة الخصوصية',
      address: '5, 8/F, Mega Cube, 8 Wang Kwong Road, Kowloon Bay, Kowloon, Hong Kong', // 原值
      ysAddress: 'ward 7, North Jhagrakhand , maharana pratap ward, manendragarh, koriya, chhattisgarh Manendragarh - 497446', // 没替换
    },
    dialogMessage: {
      reenter: 'يرجى إعادة إدخال معلومات الشخصية',
      selectServer: 'يرجى ربط الشخصية أولاً',
      selectRoleId: 'يرجى ربط الشخصية أولاً',
      fillCharacterID: 'جى إدخال معرف الشخصية',
      confirmCharacter: 'يرجى تأكيد معلومات الشخصية'
    },
    footer: {
      safe: {
        title: 'آمن',
        subTitle: 'مركز الدفع الرسمي'
      },
      convenient: {
        title: 'سهولة',
        subTitle: 'إضافة بنقرة، دفع سريع'
      },
      economical: {
        title: 'توفير',
        subTitle: 'مكافآت وفيرة'
      },
      efficient: {
        title: 'كفاءة',
        subTitle: 'وصول فوري، دون تأخير'
      }
    },
    announce: {
      type: 'الفعاليات'
    }
  },
  paySubmit: {
    paymenMethod: 'طريقة الدفع',
    prodDetails: 'تفاصيل المنتج',
    discount: 'الخصم',
    discountCode: 'كود الخصم',
    submit: 'إرسال',
    total: 'الإجمالي',
    fillDiscountCode: 'يرجى إدخال كود الخصم',
    protocal: 'لقد قرأت شروط التشغيل وأوافق على أسعار المنتجات والعناصر.',
    agree: 'يرجى الموافقة على الاتفاقية',
    currentRegion: 'المنطقة الحالية',
    paymentMethods: 'طريقة الدفع',
    items: 'المنتجات',
  },
  payFail: {
    title: 'فشلت عملية الدفع، يرجى المحاولة مرة أخرى.',
    desc: 'إذا استمرت المشكلة، يرجى تغيير طريقة الدفع أو التواصل مع خدمة العملاء.',
    loading: '...جاري التحقق من حالة الطلب',
    apiError: 'خطأ في الخدمة، يرجى المحاولة مرة أخرى لاحقاً.',
  }
};
